export default {
    unidadesMedida: [],
    unidadeMedida: {}
}